<!--
   Created by qing on 2022/5/12 下午4:11
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__rtf">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div style="width: 100%; display:flex; justify-content: flex-end;">
          <el-button
            icon="el-icon-refresh"
            type="text"
            :disabled="fetchLoading"
            @click="tableDataFetch">
            手动刷新数据
          </el-button>
        </div>

        <div class="form-third-table-container" v-loading="fetchLoading">

          <el-table
            v-if="headerList && headerList.length"
            fit
            border
            stripe
            ref="allaTable"
            :data="dataList"
            height="100%"
            :style="{borderColor: actionHexToRgba(themeColor, 0.5)}"
            class="form-third__table"
            :row-style="rowStyle"
            :header-row-style="headerRowStyle"
            :cell-style="cellStyle"
            :header-cell-style="headerCellStyle"
            max-height="600px"
            size="small">
            <el-table-column
              fixed
              type="index"
              header-align="center"
              align="center"
              width="40">
            </el-table-column>
            <el-table-column
              v-for="(item, idx) in headerList"
              :key="item.name"
              :column-key="item.name"
              :prop="item.name"
              :label="item.text"
              :width="`${item.width}px`"
              :formatter="columnFormatter"
              header-align="center"
              align="center">
            </el-table-column>
          </el-table>
        </div>
      </template>
    </van-cell>

  </div>

</template>


<script>
  import {current} from './mixin'
  import {formatDate, hexToRgba} from '../../../assets/js/Untis'

  function contrastType(val, type) {
    let typeString = null
    switch (type) {
      case 'string':
        typeString = '[object String]'
        break
      case 'number':
        typeString = '[object Number]'
        break
      case 'array':
        typeString = '[object Array]'
        break
      case 'object':
        typeString = '[object Object]'
        break
      default:
        break
    }
    return Object.prototype.toString.call(val) === typeString
  }
  export default {
    mixins: [current],
    data() {
      return {
        timer: null,
        dataList: [],
        headerList: [],
        fetchLoading: true
      }
    },
    computed: {
      themeColor() {
        return this.current.mainColor
      },
      headerMap() {
        let map = {}
        this.headerList.forEach(h => {
          map[h.name] = h
        })
        return map
      }
    },
    created() {
      this.tableDataFetch()
      document.addEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
    },
    destroyed() {
      this.clearTimer()
      document.removeEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
    },
    methods: {
      clearTimer() {
        this.fetchLoading = false
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },
      tableDataFetch() {
        this.clearTimer()
        const formSet = this.current.root
        this.fetchLoading  = true
        this.$store.dispatch('actionFormThirdTableData', {
          appId: formSet.appId, //appId
          formId: formSet.formId,  //表单的Id
          fieldId: this.current.dataId,
          data: formSet.getValues()
        }).then(res => {
          this.timer = setTimeout(() => {
            this.tableDataCycle(res.taskId)
          }, 1000)
        }).catch(console.error)
          .finally(() => {
          this.fetchLoading  = false
        })
      },
      tableDataCycle(taskId) {
        this.clearTimer()
        this.$store.dispatch('actionFormThirdTableDataCycle', {
          taskId
        }).then(res => {
          if (res.executeFinish === 0) {
            this.timer = setTimeout(() => {
              this.tableDataCycle(res.taskId)
            }, 2000)
          } else if (res.executeFinish === 1){
            this.clearTimer()
            this.dataList = res.resultInfo.dataList
            this.headerList = res.resultInfo.headerList
            this.tableWidth()
          } else if (res.executeFinish === -1){
            this.clearTimer()
            this.$alert(res.errorMsg, '获取数据失败', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        }).catch(console.error)
      },

      tableWidth() {
        const formSet = this.current.root
        this.$store.dispatch('actionFetchTableWidth', formSet.formId)
          .then(widthInfo => {
          this.headerList.forEach(item => {
            let widthItem = widthInfo.filter(f => `${this.current.dataId}_${item.name}` === f.fieldId)[0]
            this.$set(item, 'width', widthItem ? widthItem.fieldWidth : '')
          })
        }).catch(console.error)
      },
      columnFormatter(row, column, cellValue, index) {
        const field = this.headerMap[column.property]
        let h = this.$createElement
        return h('div', {
          staticClass: 'custom-cell',
        }, [
          h('div', {
            style: {
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              zIndex: -1,
            }
          }), this.commonRender(field, cellValue, h)
        ])
      },

      // 各类型数据渲染
      commonRender(field, cellValue, h) {
        if (cellValue === null) {
          return this.isEmpty()
        }
        switch (field.type) {
          // 图片
          case 'image': {
            if (contrastType(cellValue, 'array')) {
              return this.isImages(
                cellValue
              )
            } else {
              return this.isEmpty()
            }
          }
          case 'date' : {
            if (contrastType(cellValue, 'number') && cellValue > 0) {
              return formatDate(cellValue)('yyyy/MM/dd HH:mm:ss')
            } else if (contrastType(cellValue, 'string') && cellValue) {
              cellValue = Number(cellValue)
              return formatDate(cellValue)('yyyy/MM/dd HH:mm:ss')
            } else {
              return this.isEmpty()
            }
          }
          default:
            if (contrastType(cellValue, 'number')) {
              return cellValue
            } else {
              return cellValue || this.isEmpty()
            }
        }
      },
      // 为空渲染
      isEmpty() {
        const h = this.$createElement
        return h('div', {
          style: {
            padding: 0,
            minHeight: '23px'
          }
        })
      },
      // 图片渲染
      isImages(urls) {
        const miniUrls = urls
        const h = this.$createElement
        return urls.length ? h('div', {
          style: {
            display: 'flex'
          }
        }, miniUrls.map((url, idx) =>
          h('div', {
            style: {
              width: '23px',
              height: '23px',
              marginLeft: '3px',
              display: 'inline-block',
            },
            on: {
              click: e => {
                e.stopPropagation()
              },
              mousedown: e => {
                e.stopPropagation()
              },
              mouseup: e => {
                e.stopPropagation()
              }
            }
          }, [
            h('el-image', {
              props: {
                src: url,
                'preview-src-list': urls,
                fit: 'cover'
              },
              style: {
                width: '23px',
                height: '23px',
                marginLeft: '3px',
                display: 'inline-block',
                border: '1px solid #e6e6e6'
              }
            })
          ])
        )) : this.isEmpty()
      },
      rowStyle({row, rowIndex}) {
        console.log(row, rowIndex)
        if (rowIndex % 2 === 1) {
          return {
            background: hexToRgba(this.themeColor, 0.2),
            color: this.current.contentColor
          }
        } else {
          return {
            background: 'transparent',
            color: this.current.contentColor
          }
        }
      },

      headerRowStyle() {

      },
      cellStyle({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 0) {
          if (rowIndex % 2 === 1) {
            return {
              background: hexToRgba(this.themeColor, 1)
            }
          } else {
            return {
              background: '#ffffff'
            }
          }
        } else {
          return {
            textAlign: this.current.alignment,
            borderColor: hexToRgba(this.themeColor, 0.5)
          }
        }
      },
      headerCellStyle() {
        return {
          background: this.themeColor,
          borderBottomColor: hexToRgba(this.themeColor, 0.5),
          textAlign: this.current.alignment,
          color: this.current.headerColor
        }
      },

      actionHexToRgba(hex, opacity) {
        return hexToRgba(hex, opacity)
      },
      formFieldDataChange(e) {

        if (e.detail) {
          const {
            fieldId,
            formId,
            rowIdx
          } = e.detail
          if (formId === this.current.root.formId && this.current.refreshFieldIdList.includes(fieldId)) {
            this.tableDataFetch()
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .form-third-table-item {
    width: 100%;

    .form-third-table-container {
      width: 100%;
      min-height: 100px;

      .form-third__table {
        display: inline-block;
        min-width: 360px;

        .el-table__row {

          &:hover {
            > td {
              background-color: rgba(229, 104, 51, 0.2) !important;
            }
          }
        }

        .el-table-column--selection {
          >.cell {
            padding-left: 10px;
          }
        }

        .cell {
          padding: 0;

          .custom-cell {
            padding-left: 10px;
            padding-right: 10px;
            min-height: 23px;
            //.ellipsis();
          }

          .custom-sub-cell {
            min-height: 23px;
            line-height: 23px;
            padding: 8px 10px;
            border-bottom: 1px solid #e6e6e6;
            //.ellipsis();

            &:first-child {
              padding-top: 0;
            }

            &:last-child {
              border-bottom: none;
              padding-bottom: 0;
            }
          }
        }

        .el-table__header-wrapper,
        .el-table__fixed-header-wrapper {
          thead {
            th {
              background-color: #fafafa;
              color: #2b3441;

              &:last-child {
                border-bottom: none;
              }

              .cell {
                font-weight: 500;
                font-size: 14px;
              }
            }

            .cell {
              position: relative;
              height: 24px;
              line-height: 24px;
              font-weight: normal;
            }

            .caret-wrapper {
              position: absolute;
              right: 2px;
              top: -4px;
            }
          }
        }

        .el-image-viewer__wrapper {
          .el-image-viewer__close {
            color: #ffffff;
            background-color: #606266;
          }

          .el-image-viewer__mask {

          }
        }
      }

      >.el-table {
        height: 100%;
        background-color: transparent;

        th, tr, td {
          background-color: transparent;
        }


        .el-table__body-wrapper {
        }

        &:before,
        &:after {
          background: transparent;
        }
      }

      .el-table--border {
        border-right: 1px solid;
        border-bottom: 1px solid;
      }

      .el-table--striped .el-table__body tr.el-table__row--striped td {
        /*background: rgba(255, 255, 255, 0.6);*/
        background: transparent;
      }

      .empty-background__container {
        background-size: contain;
      }
    }

  }
</style>
